import {Chromeless} from '@freckle/classroom/ts/hooks/chromeless/component'
import {LoggedRoute} from '../logged-route'
import {routerV2MathAssign} from './assign'
import {
  AssessmentGrowthDetailedReportHandler,
  AssessmentSessionReportHandler,
  ClassGroupingReportHandler,
  ConstructedResponsePageHandler,
  DokAssignmentReportHandler,
  FactPracticeReportHandler,
  FactPracticeReportViewHandler,
  GenericSessionReportHandler,
  LessonAssignmentsHandler,
  ChromelessLessonAssignmentsHandler,
  LessonDaysHandler,
  LessonSlideshowHandler,
  MathAdaptiveSessionReportHandler,
  MathAssessmentGrowthReportHandler,
  MathAssessmentReportHandler,
  MathAssignmentsHandler,
  MathDiagnosticReportContainer,
  MathAdaptiveReportContainer,
  MathFactFluencyHandler,
  MathLessonListHandler,
  MathOverviewHandler,
  MathPrintPreviewAssignmentHandler,
  MathReportCardHandler,
  MathSkillsProgressReportHandler,
  MathTargetedReportHandler,
  MathTargetedAssignmentReportHandler,
  MathFocusSkillsAssignmentReportHandler,
  MathTargetedSessionReportHandler,
  MathFocusSkillsSessionReportHandler,
  PrintMathReportCardsHandler,
  PrintablesAdaptiveWrapper,
  PrintablesExampleWrapper,
  PrintablesTargetedWrapper,
  PrintablesWrapper,
  ReportCardSummariesHandler,
  StandardPageHandler,
  StandardStudentReportHandler
} from './lazy'

export const routerV2Math = [
  {
    path: '/math/session/:product/:assignmentSessionId/report',
    element: <LoggedRoute component={GenericSessionReportHandler} />
  },
  {
    path: '/chromeless/math/session/:product/:assignmentSessionId/report',
    element: (
      <Chromeless reportSizing>
        <LoggedRoute dashboardType="minimal" fullScreen component={GenericSessionReportHandler} />
      </Chromeless>
    )
  },
  {
    path: '/math-diagnostic-report',
    element: <LoggedRoute component={MathDiagnosticReportContainer} />
  },
  {
    path: '/math-adaptive-report',
    element: <LoggedRoute component={MathAdaptiveReportContainer} />
  },
  {
    path: '/session-history/math-assessment-session/:sessionId',
    element: <LoggedRoute component={AssessmentSessionReportHandler} />
  },
  {
    path: '/session-history/math-assessment/:assessmentId/session/:sessionId',
    element: <LoggedRoute component={AssessmentSessionReportHandler} />
  },
  {
    path: '/math/assessment-session/:sessionId/report',
    element: <LoggedRoute component={AssessmentSessionReportHandler} />
  },
  {
    path: '/assessment/:assessmentId/report',
    element: <LoggedRoute component={MathAssessmentReportHandler} />
  },
  {
    path: '/math/standards/students/:studentId/report',
    element: <LoggedRoute component={StandardStudentReportHandler} />
  },
  {
    path: '/math/goals/fact-fluency-overview/',
    element: <LoggedRoute component={MathFactFluencyHandler} />
  },
  {
    path: '/math/adaptive-session/:assignmentSessionId/report',
    element: <LoggedRoute component={MathAdaptiveSessionReportHandler} />
  },
  {
    path: '/standards',
    element: <LoggedRoute component={MathOverviewHandler} />
  },
  {
    path: '/standards/:standardId',
    element: <LoggedRoute component={StandardPageHandler} />
  },
  {
    path: '/math-report-card',
    element: <LoggedRoute component={MathReportCardHandler} />
  },
  {
    path: '/math-standards-report',
    element: <LoggedRoute component={MathTargetedReportHandler} />
  },
  {
    path: '/print-math-report-cards',
    element: <LoggedRoute component={PrintMathReportCardsHandler} />
  },
  {
    path: '/report-card-summaries',
    element: <LoggedRoute component={ReportCardSummariesHandler} />
  },
  {
    path: '/math/targeted-session/:assignmentSessionId/report',
    element: <LoggedRoute component={MathTargetedSessionReportHandler} />
  },
  {
    path: '/chromeless/math/targeted-session/:assignmentSessionId/report',
    element: (
      <Chromeless reportSizing>
        <LoggedRoute
          dashboardType="minimal"
          fullScreen
          component={MathTargetedSessionReportHandler}
        />
      </Chromeless>
    )
  },
  {
    path: '/math/focus-skills-practice-session/:assignmentSessionId/report',
    element: <LoggedRoute component={MathFocusSkillsSessionReportHandler} />
  },
  {
    path: '/math/assignments',
    element: <LoggedRoute component={MathAssignmentsHandler} />
  },
  {
    path: '/lessons',
    element: <LoggedRoute component={MathLessonListHandler} />
  },
  {path: '/printables', element: <LoggedRoute component={PrintablesWrapper} />},
  {
    path: '/printables/example',
    element: <LoggedRoute component={PrintablesExampleWrapper} fullScreen />
  },
  {
    path: '/printables/adaptive/domain/:domainId',
    element: <LoggedRoute component={PrintablesAdaptiveWrapper} fullScreen />
  },
  {
    path: '/printables/targeted/skill/:skillId',
    element: <LoggedRoute component={PrintablesTargetedWrapper} fullScreen />
  },
  {
    path: '/lessons/:lessonId',
    element: <LoggedRoute component={LessonDaysHandler} />
  },
  {
    path: '/lessons/:lessonId/days/:dayNum/slideshow',
    element: <LoggedRoute component={LessonSlideshowHandler} fullScreen />
  },
  {
    path: '/chromeless/lessons/:lessonId/assignments',
    element: (
      <Chromeless>
        <LoggedRoute
          dashboardType="minimal"
          fullScreen
          component={ChromelessLessonAssignmentsHandler}
        />
      </Chromeless>
    )
  },
  {
    path: '/lessons/:lessonId/assignments',
    element: <LoggedRoute component={LessonAssignmentsHandler} />
  },
  {
    path: '/class-grouping-report',
    element: <LoggedRoute component={ClassGroupingReportHandler} />
  },
  {
    path: '/math-assessment-growth',
    element: <LoggedRoute component={MathAssessmentGrowthReportHandler} />
  },
  {
    path: '/constructed-responses',
    element: <LoggedRoute component={ConstructedResponsePageHandler} />
  },
  {
    path: '/math-assessment-growth-detailed',
    element: <LoggedRoute component={AssessmentGrowthDetailedReportHandler} />
  },
  {
    path: '/fact-practice-report/students/:studentId/operations/:operation',
    element: <LoggedRoute component={FactPracticeReportViewHandler} />
  },
  {
    path: '/fact-practice-reports',
    element: <LoggedRoute component={FactPracticeReportHandler} />
  },
  {
    path: '/math/reports/targeted-practice/:assignmentId',
    element: <LoggedRoute component={MathTargetedAssignmentReportHandler} />
  },
  {
    path: '/chromeless/math/reports/targeted-practice/:assignmentId',
    element: (
      <Chromeless reportSizing>
        <LoggedRoute
          dashboardType="minimal"
          fullScreen
          component={MathTargetedAssignmentReportHandler}
        />
      </Chromeless>
    )
  },
  {
    path: '/math/reports/dok-assignment/:assignmentId',
    element: <LoggedRoute component={DokAssignmentReportHandler} />
  },
  {
    path: '/chromeless/math/reports/dok-assignment/:assignmentId',
    element: (
      <Chromeless reportSizing>
        <LoggedRoute dashboardType="minimal" fullScreen component={DokAssignmentReportHandler} />
      </Chromeless>
    )
  },
  {
    path: '/reports/math-focus-skills-practice/:assignmentId',
    element: <LoggedRoute component={MathFocusSkillsAssignmentReportHandler} />
  },
  {
    path: '/math/overview',
    element: <LoggedRoute component={MathOverviewHandler} />
  },
  {
    path: '/math-skills-progress-report',
    element: <LoggedRoute component={MathSkillsProgressReportHandler} />
  },
  {
    path: '/math/print/:product/:sessionId',
    element: <LoggedRoute component={MathPrintPreviewAssignmentHandler} fullScreen />
  },
  ...routerV2MathAssign
]
